import { checkoutReviewAndSubmitHeaderStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import get from "@insite/mobius/utilities/get";
import getColor from "@insite/mobius/utilities/getColor";
import { TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

checkoutReviewAndSubmitHeaderStyles.backButton = {
    variant: "secondary",
    hoverMode: "none",
    css: css`
        padding: 10px 34px;
        background: ${getColor("primary.contrast")};
        color: ${getColor("text.accent")};
        border: 2px solid ${getColor("text.accent")};
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        padding: 0 21px;
                        width: 50%;
                    `,
                    css`
                        flex-shrink: 1;
                    `,
                    css`
                        flex-shrink: 1;
                    `,
                    css`
                        flex-shrink: 1;
                    `,
                    css`
                        flex-shrink: 1;
                    `,
                ],
                "max",
            )}
    `,
};
checkoutReviewAndSubmitHeaderStyles.headingText = {
    css: css`
        color: ${getColor("text.main")} !important;
        line-height: 38px;
        font-size: 28px;
        font-weight: 600;
        font-family: Mulish;
        display: block;
        margin-bottom: 0px;
    `
};
checkoutReviewAndSubmitHeaderStyles.placeOrderButton = {
    css: css`
        padding: 10px 34px;
        flex-shrink: 0;
        margin-left: 10px;
        background: ${getColor("text.main")} !important;
        border: 2px solid ${getColor("text.main")} !important;
        > span {
            color: ${getColor("primary.contrast")} !important;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 50%;
                    `,
                    css`
                        width: unset;
                    `,
                ],
                "min",
            )}
    `,
};

checkoutReviewAndSubmitHeaderStyles.buttonsWrapper = {
    css: css`
        display: flex;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    width: 100%;
                    background: ${getColor("common.background")({ theme })};
                    justify-content: center;
                    z-index: ${get(theme, "zIndex.stickyFooter")};
                    margin-top: 20px;
                `,
                css`
                    margin-left: 16px;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
            ])}
    `,
};

checkoutReviewAndSubmitHeaderStyles.gridItem = {
    width: 12,
    css: css`
        flex-wrap: wrap;
    `,
};
